module.exports = __webpack_public_path__ + "img/IMG_9432_L_Black_MockedUp.22d35ede.jpg";